<p8-layout-settings-page>
  <mat-card>
    <mat-card-title>
      <p8-layout-settings-header [titlePath]="['Gestion des éliminations']"
                                 [iconRacine]="'apps'"></p8-layout-settings-header>
    </mat-card-title>
    <mat-card-content fxLayout="column">
      <div style="padding-top: 5px" fxFlexAlign="end">
        <div fxLayout="column">
          <button color="accent" mat-raised-button (click)="addBordereau()" routerLinkActive="true"
                  matTooltip="Cliquer pour créer un nouveau bordereau">
            <mat-icon>add</mat-icon>
            NOUVEAU BORDEREAU
          </button>
        </div>
      </div>
      <div class="manage_deposit">
        <app-data-table
          [borderHeader]="true"
          [colorHeader]="'#fff'"
          [colorHeaderBackground]="'#212529'"
          [actions]="actions"
          [columns]="columns"
          [dataSource]="dsBels"
          [extraParams]="extraParams"
          [filterDisplay]="true"
          [flexAction]="5"
          [flexColumn]="90"
          [fontSizeCell]="'0.9em'"
          [minFilter]="1" [pageSize]="10"
          [pageSizesList]="[5,10,25]" [placeHolderFilter]="'Rechercher des bordereaux'"
          [refreshButton]="true"
          [refreshIcone]="false"
          [showFirstLastButtons]="true"
          [showLoader]="true"
          [loaderMask]="true"
          [toolTipFilter]="'Rechercher des bordereaux'"
          [filtersLegend]="true">
        </app-data-table>
      </div>
    </mat-card-content>
  </mat-card>
</p8-layout-settings-page>
